<div class="nexo-loading" role="status" aria-live="polite">
  <div class="nexo-loading__content">
    <svg lucideLoaderCircle aria-hidden="true" class="nexo-loading__icon"></svg>
    <span class="nexo-loading__label">{{ label() }}</span>
  </div>
</div>
